import React from 'react';
import LoginForm from './form';
import styles from './style/index.module.less';
function Login() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['content-inner']
  }, /*#__PURE__*/React.createElement(LoginForm, null))));
}
Login.displayName = 'LoginPage';
export default Login;